<dv-grid
  [actions]="actions"
  (filtersCleared)="filtersCleared()"
  [alwaysShowFilterButton]="alwaysShowFilterButton">
  <dv-panel
    class="on-call-panel"
    [showExpandButton]="true"
    [showPinButton]="false"
    [isPinned]="true"
    [isClosedPanelVisible]="true"
    [closedPanelTitle]="' '"
    [isOpen]="true">
    <div class="on-call-panel__form-wrapper">
      <div class="on-call-panel__first-group">
        <div class="on-call-panel__group-title">
          {{ 'OnCallGridPanel.LocationStatusTitle' | translate }}
        </div>
        <dv-dynamic-form
          [elements]="locationStatusElements | translateElements"
          [formGroup]="panelFormGroup"></dv-dynamic-form>
      </div>
      <div class="on-call-panel__second-group">
        <div class="on-call-panel__group-title">
          {{ 'OnCallGridPanel.DepartmentUserLocationTitle' | translate }}
        </div>
        <dv-dynamic-form
          [elements]="departmentUserLocationElements | translateElements"
          [formGroup]="panelFormGroup"></dv-dynamic-form>
      </div>
      <div class="on-call-panel__third-group">
        <div class="on-call-panel__group-title">
          {{ 'OnCallGridPanel.UserPropertyTitle' | translate }}
        </div>
        <dv-dynamic-form
          [elements]="userPropertyElements | translateElements"
          [formGroup]="panelFormGroup"></dv-dynamic-form>
      </div>
      <div class="on-call-panel__fourth-group">
        <div class="on-call-panel__group-title">
          {{ 'OnCallGridPanel.VehiclePropertyTitle' | translate }}
        </div>
        <dv-dynamic-form
          [elements]="vehiclePropertyElements | translateElements"
          [formGroup]="panelFormGroup"></dv-dynamic-form>
      </div>
    </div>
  </dv-panel>
  <dv-quick-filter [agGrid]="agGrid" [filters]="quickFilters">
  </dv-quick-filter>
  <ag-grid-angular
    class="fleet-grid"
    #agGrid
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    (rowDataUpdated)="onRowDataUpdated($event)"
    (filterChanged)="onFilterChanged($event)"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</dv-grid>
